import { createFileRoute, } from '@tanstack/react-router';
import { assertDefined, } from '@tymia/shared';
import { api, } from '../../../../../api/Api.js';
import { configStore, } from '../../../../../common/config/ConfigStore.js';
export const Route = createFileRoute('/client/account/change-password')({
    shouldReload: false,
    async loader() {
        const config = configStore.get();
        if (config.state !== 'initialized') {
            throw new Error('Config not initialized');
        }
        const email = config.principal.email;
        assertDefined(email);
        return await api.principal.resetPassword.request({
            email,
        });
    },
});
//# sourceMappingURL=ClientAccountChangePasswordRoute.js.map